var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-details-dialog" },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            fullscreen: true,
            "close-on-press-escape": false,
            "show-close": false,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "order-details-title-bar",
              attrs: { id: "order-details-title" },
            },
            [
              _c("div", { staticClass: "order-number" }, [
                _vm._v(
                  "\n        Return #" +
                    _vm._s(_vm.returnOrderDetails.id) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "el-dialog__headerbtn",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("update:visible", false)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-dialog__close el-icon el-icon-close",
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "div",
                {
                  staticClass: "order-details-body",
                  attrs: { id: "order-details-body" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "order-details-timeline" },
                    [
                      _c("ReturnOrderTimeline", {
                        attrs: { "return-order": _vm.returnOrder },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { border: "1px solid #DEE5EC" } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        flex: "3",
                        "overflow-y": "scroll",
                        display: "flex",
                        "flex-direction": "column",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.generateLabelFailed,
                              expression: "generateLabelFailed",
                            },
                          ],
                          staticClass: "error-message",
                          staticStyle: {
                            background: "var(--light-negative-muted, #fcefef)",
                            color: "var(--light-negative-base, #d4231a)",
                          },
                        },
                        [
                          _vm._v(
                            "\n          Return label was not generated. Please check the customer address or try again later.\n          "
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "el-dialog__headerbtn",
                              attrs: { type: "button", "aria-label": "Close" },
                              on: {
                                click: function ($event) {
                                  _vm.generateLabelFailed = false
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-dialog__close el-icon el-icon-close",
                                staticStyle: { color: "#d4231a" },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.generateLabelSuccessful,
                              expression: "generateLabelSuccessful",
                            },
                          ],
                          staticClass: "error-message",
                          staticStyle: {
                            background: "var(--light-positive-muted, #F0F8F0)",
                            color: "var(--light-positive-base, #178019)",
                          },
                        },
                        [
                          _vm.isNarvarReturn
                            ? [
                                _vm._v(
                                  "\n            Narvar return label is available.\n          "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n            Return label has been generated and sent to " +
                                    _vm._s(
                                      _vm.returnOrderDetails.customer.email
                                    ) +
                                    ".\n          "
                                ),
                              ],
                          _vm._v(" "),
                          _vm.returnLabelUrl
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.returnLabelUrl,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                  },
                                },
                                [_vm._v("View return label")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "el-dialog__headerbtn",
                              attrs: { type: "button", "aria-label": "Close" },
                              on: {
                                click: function ($event) {
                                  _vm.generateLabelSuccessful = false
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-dialog__close el-icon el-icon-close",
                                staticStyle: { color: "#178019" },
                              }),
                            ]
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "order-details-data",
                          attrs: { id: "order-details-data" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-row items-center" },
                            [
                              _c("div", { staticClass: "order-number" }, [
                                _vm._v(
                                  "\n              Return #" +
                                    _vm._s(_vm.returnOrderDetails.id) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("OrderStatus", {
                                attrs: {
                                  "order-status": _vm.returnOrderDetails.status,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-row items-center",
                              staticStyle: { margin: "16px 0" },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "font-weight": "500" } },
                                [
                                  _vm._v(
                                    "\n              Date Placed:\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-left": "4px" } },
                                [
                                  _c("time-zone-formatter", {
                                    attrs: {
                                      "output-format": "MMM DD, YYYY",
                                      "current-time":
                                        _vm.returnOrderDetails.created_at,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-weight": "500",
                                    "margin-left": "26px",
                                  },
                                },
                                [_vm._v("\n              Email:\n            ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-left": "4px" } },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.returnOrderDetails.customer.email
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { id: "order-details-items" } },
                            _vm._l(
                              _vm.returnOrderDetails.return_items,
                              function (item, idx) {
                                return _c(
                                  "return-order-details-item-view",
                                  _vm._b(
                                    {
                                      key: idx,
                                      staticStyle: { "margin-bottom": "8px" },
                                    },
                                    "return-order-details-item-view",
                                    item,
                                    false
                                  )
                                )
                              }
                            ),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "order-details-item",
                              staticStyle: {
                                "font-weight": "500",
                                "margin-left": "0px",
                                "margin-top": "36px",
                              },
                            },
                            [_vm._v("\n            Shipping\n          ")]
                          ),
                          _vm._v(" "),
                          _vm.returnOrderDetails.return_labels.length === 0
                            ? _c(
                                "div",
                                { staticClass: "item-details" },
                                [_c("shipment-details-available-soon")],
                                1
                              )
                            : _c(
                                "div",
                                { attrs: { id: "order-details-item" } },
                                _vm._l(
                                  _vm.returnOrderDetails.return_labels,
                                  function (item, idx) {
                                    return _c("return-order-shipping-view", {
                                      key: idx,
                                      staticStyle: { "margin-bottom": "8px" },
                                      attrs: {
                                        "tracking-id": item.tracking_id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "order-details-item",
                              staticStyle: {
                                "font-weight": "500",
                                "margin-left": "0px",
                                "margin-top": "36px",
                              },
                            },
                            [_vm._v("\n            Payment\n          ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { id: "order-details-item" } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticStyle: {
                                    "border-radius": "4px !important",
                                    border: "1px solid #dee5ec",
                                    "margin-right": "12px",
                                  },
                                  attrs: {
                                    "class-name": "item-card",
                                    shadow: "never",
                                    "body-style": "margin: 8px;",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex flex-row",
                                      staticStyle: {
                                        margin: "8px 8px 8px 8px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex-1",
                                          staticStyle: { margin: "7px" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "item-id flex flex-row",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "flex-1" },
                                                [
                                                  _vm._v(
                                                    "\n                      Additional fees\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formattedAmount(
                                                      _vm.additional_fees
                                                        .amount,
                                                      _vm.additional_fees
                                                        .currency_code
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("el-divider"),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "item-name flex flex-row",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "flex-1 flex" },
                                                [
                                                  _c("div", [
                                                    _vm._v(
                                                      "\n                        Total refund\n                      "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.formattedAmount(
                                                        _vm.returnOrderDetails
                                                          .refund_info.amount,
                                                        _vm.returnOrderDetails
                                                          .refund_info.currency
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "order-details-item flex flex-row",
                              staticStyle: { "font-weight": "500" },
                            },
                            [
                              _c("div", { staticClass: "flex-1 flex" }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-weight": "500",
                                      "margin-left": "0px",
                                      "margin-top": "24px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Customer Info\n              "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { id: "order-details-items" } },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "item-card",
                                  staticStyle: {
                                    "border-radius": "4px !important",
                                    border: "1px solid #dee5ec",
                                  },
                                  attrs: {
                                    shadow: "never",
                                    "body-style": "margin: 0px;",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex flex-row",
                                      staticStyle: {
                                        margin: "8px 24px 8px 8px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex-1",
                                          staticStyle: { margin: "8px" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "flex flex-row",
                                              staticStyle: {
                                                margin: "0px 0px 8px 0px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "flex-1" },
                                                [
                                                  _c("strong", [
                                                    _vm._v("Delivery Address"),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "flex flex-row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "flex-1" },
                                                [
                                                  _vm._v(
                                                    "\n                      Name\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "item-price" },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.returnOrderDetails
                                                          .customer.name
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "flex flex-row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "flex-1" },
                                                [
                                                  _vm._v(
                                                    "\n                      Phone number\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "item-price" },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.returnOrderDetails
                                                          .customer.phone
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "flex flex-row" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "flex-1",
                                                  staticStyle: {
                                                    margin: "0px 0px 24px 0px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Email\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "item-price" },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.returnOrderDetails
                                                          .customer.email
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "flex flex-row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "flex-1" },
                                                [
                                                  _vm._v(
                                                    "\n                      Street\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "item-price" },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.returnOrderDetails
                                                          .customer.address_1
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "flex flex-row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "flex-1" },
                                                [
                                                  _vm._v(
                                                    "\n                      City\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "item-price" },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.returnOrderDetails
                                                          .customer.city
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "flex flex-row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "flex-1" },
                                                [
                                                  _vm._v(
                                                    "\n                      State/province/area\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "item-price" },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.returnOrderDetails
                                                          .customer.state
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "flex flex-row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "flex-1" },
                                                [
                                                  _vm._v(
                                                    "\n                      Zip code\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "item-price" },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.returnOrderDetails
                                                          .customer.zip
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "flex flex-row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "flex-1" },
                                                [
                                                  _vm._v(
                                                    "\n                      Country\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "item-price" },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.returnOrderDetails
                                                          .customer.country
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "order-details-footer",
              attrs: { id: "order-details-footer" },
            },
            [
              _c(
                "el-dropdown",
                {
                  attrs: { trigger: "click" },
                  on: { command: _vm.handleAction },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "choose_action_button",
                      attrs: { plain: "" },
                    },
                    [
                      _vm._v("\n          Choose Action "),
                      _c("i", {
                        staticClass: "el-icon-arrow-down el-icon--right",
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    {
                      staticStyle: {
                        "max-height": "unset !important",
                        overflow: "unset !important",
                      },
                      attrs: { slot: "dropdown" },
                      slot: "dropdown",
                    },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          staticClass: "choose_action_item",
                          attrs: { command: "resend_label" },
                        },
                        [_vm._v("\n            Resend Label\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            disabled: !_vm.isNarvarReturn,
                            content: "Managed by Narvar",
                            placement: "left",
                          },
                        },
                        [
                          _c(
                            "span",
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  staticClass:
                                    "choose_action_item action_cancel",
                                  attrs: {
                                    disabled:
                                      _vm.isNarvarReturn ||
                                      !_vm.returnOrderDetails.closable,
                                    command: "cancel_return",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Cancel Return\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showCancelConfirmation
        ? _c("ConfirmCancel", {
            attrs: { visible: _vm.showCancelConfirmation },
            on: {
              "update:visible": function ($event) {
                _vm.showCancelConfirmation = $event
              },
              "cancel-return": _vm.confirmCancel,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }